import { format } from 'date-fns';

export const DEFAULT_DATE_FORMAT = 'MM/dd/yyyy';
const DEFAULT_DATE_TIME_FORMAT_OTIONS = { year: 'numeric', month: 'long', day: 'numeric' };

const formatDateString = (
  date: Date,
  options: Intl.DateTimeFormatOptions = DEFAULT_DATE_TIME_FORMAT_OTIONS
): string => date.toLocaleDateString('en-US', options);

const formatUiDate = (
  dateString: string,
  dateFormat: 'MM/dd/yyyy' | 'MM.dd.yyyy' = DEFAULT_DATE_FORMAT
) => {
  if (!dateString) return '';

  return format(new Date(dateString), dateFormat);
};

export { formatDateString, formatUiDate };
